<template>
  <div class="create-invoice-dialog">
    <el-dialog width="750px" class="common-dialog build-dialog" center :modal-append-to-body="false" :close-on-click-modal="false" :visible.sync="visible" title="申请开票">
      <submit-invoice-content ref="submitInvoiceRef" :ids="ids" @get-data="getData" />
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeHandler" size="small">取 消</el-button>
        <el-button type="primary" @click="confirm" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import submitInvoiceContent from '@components/personalPage/components/SubmitInvoiceContent'
export default {
  name: 'CreateInvoiceDialog',
  components: { submitInvoiceContent },
  data() {
    return {
      visible: false,
      invoiceInfo: {
        bankAccount: ' ',
        openBank: '',
        invoiceAddress: '',
        invoicePhone: '',
        invoiceTitle: '',
        taxpayerCode: ''
      },
      addressId: '',
      ids: ''
    }
  },
  methods: {
    open(ids) {
      this.visible = true
      this.ids = ids
    },
    closeHandler() {
      this.$refs.submitInvoiceRef.closeHandler()
      this.visible = false
    },
    confirm() {
      this.$refs.submitInvoiceRef.confirm()
    },
    getData() {
      this.$parent.getData()
    }
  }
}
</script>

<style scoped lang="scss"></style>
